/**
 * Purpose: Skeleton states for the Business Detail page (progressive loading, D-16).
 * Inputs: none — purely presentational placeholders.
 * Outputs: HeroSkeleton, SidebarSkeleton, ModuleSkeleton.
 */
import React from 'react';
import { Skeleton, SkeletonText } from '../../ui';

export const HeroSkeleton = () => (
  <div aria-busy="true" aria-label="Loading business">
    <div className="mx-auto max-w-screen-2xl px-4 pt-4 sm:px-6 lg:px-8">
      <Skeleton className="h-36 w-full rounded-2xl sm:h-44 md:h-52 lg:h-64" />
    </div>
    <div className="mx-auto flex max-w-screen-2xl gap-3 px-4 py-4 sm:gap-4 sm:px-6 lg:px-8">
      <Skeleton className="h-12 w-12 flex-shrink-0 rounded-xl sm:h-14 sm:w-14" />
      <div className="flex-1 space-y-2.5">
        <Skeleton className="h-6 w-1/2 max-w-xs" />
        <Skeleton className="h-4 w-1/3 max-w-[10rem]" />
        <Skeleton className="h-4 w-2/3 max-w-md" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-24 rounded-xl" />
          <Skeleton className="h-9 w-24 rounded-xl" />
          <Skeleton className="h-9 w-24 rounded-xl" />
        </div>
      </div>
    </div>
  </div>
);

export const SidebarSkeleton = () => (
  <div aria-busy="true" className="space-y-4">
    <div className="rounded-2xl border border-gray-200 p-5 dark:border-gray-700">
      <Skeleton className="mb-4 h-4 w-24" />
      <SkeletonText lines={4} />
    </div>
    <div className="rounded-2xl border border-gray-200 p-5 dark:border-gray-700">
      <Skeleton className="mb-4 h-4 w-24" />
      <SkeletonText lines={3} />
    </div>
  </div>
);

export const ModuleSkeleton = () => (
  <div aria-busy="true" className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900 sm:p-5">
    <Skeleton className="mb-4 h-5 w-40" />
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {[0, 1, 2].map((i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="aspect-[4/3] w-full" />
          <Skeleton className="h-3.5 w-3/4" />
          <Skeleton className="h-3.5 w-1/2" />
        </div>
      ))}
    </div>
  </div>
);
